import * as t from 'io-ts';
import { LegDynamicType } from './leg';
import { BookingImageDynamicType } from './bookingImage';
import { TripDynamicType } from 'acscp/api/models/trip';
import { quotingNotesDynamicType } from 'acscp/api/models/quotingNotes';
import { PriceModificationDynamicType } from 'acscp/api/models/priceModification';
import { CargoTypeInformationDynamicType } from 'acscp/api/models/cargoTypeInformation';
import { DepartmentType } from 'acscp/api/models/customTypes/department';
import {QuoteTypeDynamicType} from 'acscp/api/models/customTypes/quoteType';
import { AircraftCargoInformationDynamicType } from 'acscp/api/models/aircraftCargoInformation';
import { DateTime } from 'acscp/api/models/customTypes/dateTime';
import { TimeDynamicType } from 'acscp/api/models/customTypes/timeType';
import { DurationDynamicType } from 'acscp/api/models/customTypes/duration';
import { AmenityDynamicType } from 'acscp/api/models/amenity';

export const QuoteDynamicType = t.interface({
    id: t.string,
    department: DepartmentType,
    order: t.number,
    status: t.string,
    legs: t.array(LegDynamicType),
    trips: t.array(TripDynamicType),
    tripIdentifier: t.union([t.string, t.null]),
    quoteTitle: t.union([t.string, t.null]),
    aircraftYearOfManufacture: t.string,
    aircraftYearOfRefurbishment: t.union([t.string, t.null]),
    aircraftSeatingCapacityString: t.union([t.string, t.null]),
    sellCurrency: t.union([t.string, t.null]),
    sellPrice: t.union([t.number, t.null]),
    userAcceptanceNotes: t.union([t.string, t.null]),
    aircraftType: t.union([t.string, t.null]),
    images: t.array(BookingImageDynamicType),
    airline: t.union([t.string, t.null]),
    alternativeAirlineNames: t.union([t.array(t.string), t.null]),
    cancellationTerms: t.union([t.string, t.null]),
    isAmex: t.boolean,
    amexPriceNote: t.union([t.string, t.null]),
    amexNotes: t.union([t.string, t.null]),
    isJetCardQuote: t.boolean,
    jetCardRate: t.union([t.number, t.null]),
    jetCardRateCurrency: t.union([t.string, t.null]),
    additionalTerms: t.union([t.string, t.null]),
    jetCardStandardCancellationTermsText: t.union([t.string, t.null]),
    jetCardCancellationTermsImmediateText: t.union([t.string, t.null]),
    jetCardCancellationTermsThreshold1Text: t.union([t.string, t.null]),
    jetCardCancellationTermsThreshold2Text: t.union([t.string, t.null]),
    jetCardCancellationTermsThreshold3Text: t.union([t.string, t.null]),
    savingsMade: t.union([t.string, t.null]),
    additionalCosts: t.union([t.string, t.null]),
    quotingNotes: quotingNotesDynamicType,
    amenities: t.array(AmenityDynamicType),
    priceInclusions: t.array(PriceModificationDynamicType),
    priceExclusions: t.array(PriceModificationDynamicType),
    priceOptions: t.union([t.string, t.null]),
    baggageAllowanceNotes: t.union([t.string, t.null]),
    seatingConfigurationNotes: t.union([t.string, t.null]),
    billableHours: t.union([t.number, t.null]),
    totalHours: t.union([t.number, t.null]),
    shouldShowPictureTypicalExampleText: t.boolean,
    cargoTypeInformation: t.array(CargoTypeInformationDynamicType),
    cargoDimensions: t.union([t.string, t.null]),
    quoteType: QuoteTypeDynamicType,
    goNowPositionTime: t.union([DateTime, t.null]),
    goNowPositionTimeType: t.union([TimeDynamicType, t.null]),
    goNowPositionDuration: t.union([DurationDynamicType, t.null]),
    aircraftCargoInformation: AircraftCargoInformationDynamicType,
    charterType: t.union([t.string, t.null]),
    sellType: t.union([t.string, t.null]),
    approvalsRequired: t.union([t.string, t.null]),
    isCrewPerDiemIncluded: t.union([t.boolean, t.null]),
    isRateIncludedDisplayedOnQuote: t.union([t.boolean, t.null]),
    isRateExcludedDisplayedOnQuote: t.union([t.boolean, t.null]),
    crews: t.union([t.string, t.null]),
    acmiRate: t.union([t.string, t.null]),
    acmiRateCurrency: t.union([t.string, t.null]),
    excessHours: t.union([t.string, t.null]),
    excessHoursCurrency: t.union([t.string, t.null]),
    registration: t.union([t.string, t.null]),
});

export type Quote = t.TypeOf<typeof QuoteDynamicType>;
